"use strict";
import classNames from "classnames";
import { connect } from "react-redux";
const DocumentBrowserShell = React.createClass({
  propTypes: {
    mainImageTitle: React.PropTypes.node.isRequired,
    children: React.PropTypes.node,
    closeLink: React.PropTypes.node,
    expandLink: React.PropTypes.node,
    popoutLink: React.PropTypes.node,
    popoutReplacementChild: React.PropTypes.node,
    componentSelected: React.PropTypes.func,
    closeDocumentViewerPopout: React.PropTypes.func,
    selectableComponents: React.PropTypes.array,
    selectedComponent: React.PropTypes.object
  },
  render() {
    if (this.props.hideDocViewer) {
      let content = this.props.popoutReplacementChild;
      if (!content) {
        content = /* @__PURE__ */ React.createElement("div", { className: "document-indexer__hidden-state" }, "Document Viewer Hidden.");
      }
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser", style: { overflow: "auto" } }, /* @__PURE__ */ React.createElement("div", { style: { float: "right", padding: "5px" } }, /* @__PURE__ */ React.createElement("a", { onClick: () => this.props.closeDocumentViewerPopout(), className: "icon-document-collapse" })), content);
    } else {
      return (
        // chrome 53 on windows needs the maxWidth, or this box
        // doesn't flex correctly
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "document-browser document-indexer__document-browser-wrapper",
            style: { maxWidth: "100%" }
          },
          /* @__PURE__ */ React.createElement("div", { className: "document-browser__header" }, /* @__PURE__ */ React.createElement("div", { className: "document-browser__header-component-selection" }, /* @__PURE__ */ React.createElement("div", { className: "component-selector" }, this.componentSelections())), /* @__PURE__ */ React.createElement("div", { className: "document-browser__header-current" }, this.props.mainImageTitle), /* @__PURE__ */ React.createElement("div", { className: "document-browser__header-documents" }), this.closeLink(), this.expandLink(), this.popoutLink()),
          /* @__PURE__ */ React.createElement("div", { className: "row document-browser__container" + (this.props.annotating ? " document-browser__annotating" : "") }, this.props.children)
        )
      );
    }
  },
  componentSelections() {
    if (!this.props.selectableComponents) {
      return null;
    }
    return this.props.selectableComponents.map((component) => {
      const active = this.props.selectedComponent && component.label == this.props.selectedComponent.label;
      const css = classNames({ active });
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          onClick: () => this.componentSelected(component),
          key: `component-selector-${component.label}`,
          className: css
        },
        component.label
      );
    });
  },
  componentSelected(component) {
    if (this.props.componentSelected) {
      this.props.componentSelected(component);
    }
  },
  closeLink() {
    if (this.props.closeLink) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__header-close-link" }, this.props.closeLink);
    }
  },
  expandLink() {
    if (this.props.expandLink) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__header-expand-link" }, this.props.expandLink);
    }
  },
  popoutLink() {
    if (this.props.popoutLink) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__header-popout-link" }, this.props.popoutLink);
    }
  }
});
const connectedDocumentBrowserShell = connect(
  (state) => ({
    annotating: state.annotationMode.annotating
  })
)(DocumentBrowserShell);
export default connectedDocumentBrowserShell;
